module.exports = __webpack_public_path__ + "img/31.8c171a77.svg";